// @ts-ignore
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faAddressCard,
  faBookmark,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCity,
  faCoffee,
  faCog,
  faDog,
  faEllipsisH,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faFile,
  faFilter,
  faFingerprint,
  faGlobeAmericas,
  faHeart,
  faHome,
  faHourglassEnd,
  faHourglassStart,
  faIdBadge,
  faInfoCircle,
  faLock,
  faLockOpen,
  faMapMarkerAlt,
  faPhoneAlt,
  faPlus,
  faQrcode,
  faRoad,
  faSearch,
  faShareAlt,
  faSignature,
  faSms,
  faSort,
  faStar,
  faStarOfLife,
  faStreetView,
  faTransgender,
  faTrash,
  faUndo,
  faUser,
  faUserSecret,
  faWheelchair,
  faCalendar,
  faMapPin,
  faClock,
  faPrint,
  faPlusCircle,
  faChevronCircleRight,
  faChevronCircleLeft,
  faChevronCircleUp,
  faChevronCircleDown,
  faBus,
  faBusAlt,
  faCreditCard,
  faShieldAlt,
  faQuestionCircle,
  faEdit,
  faExternalLinkAlt,
  faCompass,
  faBarcode,
  faEuroSign,
  faMapMarked
} from "@fortawesome/free-solid-svg-icons";

import { faGoogle, faFacebook, faGooglePlus, faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import {
  faSquare as farSquare,
  faCheckSquare as farCheckSquare,
  faTimesCircle as farTimesCircle,
} from '@fortawesome/free-regular-svg-icons';

library.add(faAddressCard);
library.add(faBookmark);
library.add(faCalendar);
library.add(faCheckCircle);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCity);
library.add(faClock);
library.add(faCoffee);
library.add(faCog);
library.add(faDog);
library.add(faEllipsisH);
library.add(faEnvelope);
library.add(faExchangeAlt);
library.add(faExclamationCircle);
library.add(faFile);
library.add(faFilter);
library.add(faFacebook);
library.add(faFingerprint);
library.add(faGlobeAmericas);
library.add(faGoogle);
library.add(faGooglePlus);
library.add(faHeart);
library.add(faHome);
library.add(faHourglassEnd);
library.add(faHourglassStart);
library.add(faIdBadge);
library.add(faInfoCircle);
library.add(faLock);
library.add(faLockOpen);
library.add(faMapMarkerAlt);
library.add(faMapPin);
library.add(faPhoneAlt);
library.add(faPlus);
library.add(faQrcode);
library.add(farCheckSquare);
library.add(faRoad);
library.add(faShareAlt);
library.add(faSms);
library.add(farSquare);
library.add(faSearch);
library.add(faSignature);
library.add(faSort);
library.add(faStar);
library.add(faStarOfLife);
library.add(faStreetView);
library.add(faTelegram);
library.add(faTransgender);
library.add(faTrash);
library.add(faUndo);
library.add(faUser);
library.add(faUserSecret);
library.add(faWheelchair);
library.add(faWhatsapp);
library.add(faMapPin);
library.add(faPrint);
library.add(farTimesCircle);
library.add(faPlusCircle);
library.add(faChevronCircleUp);
library.add(faChevronCircleDown);
library.add(faChevronCircleLeft);
library.add(faChevronCircleRight);
library.add(faBus);
library.add(faBusAlt);
library.add(faCreditCard);
library.add(faShieldAlt);
library.add(faQuestionCircle);
library.add(faEdit);
library.add(faExternalLinkAlt);
library.add(faCompass);
library.add(faBarcode);
library.add(faEuroSign);
library.add(faMapMarked);

Vue.component('font-awesome-icon', FontAwesomeIcon);
